module.exports = __webpack_public_path__ + "static/Learning_Paths_Logo-6b0b8ba85666a6d73a8ad9bd6c77f1be.png";